import React, { useState, useRef } from 'react'
import { DatePicker } from 'meinian-package/src/component'
import moment from 'moment'
import qs from 'qs'
import LineChart from 'view/components/newCollectLineChart'
import MemberContribute from 'view/components/memberContribute'
import UserSelect from 'view/components/userSelect'
import request from 'meinian-package/src/utils/request'
import cloneDeep from 'lodash/cloneDeep'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import { useLatest } from 'ahooks'
import AnalysisOverview from '../../../../components/analysisOverview'
import styles from './index.module.less'

export default () => {
  const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [baseParams, setBaseParams] = useState({
    userId: null,
    inspirationId: qsParams.inspirationId
  })
  const [params, setParams] = useState({})
  const paramsRef = useLatest(params)
  const [collectOption, setCollectOption] = useState([])
  const [checkOption, setCheckOption] = useState([])
  const collectData = useAsyncLoading({ fetchData: (_params) => fetchCollectData(_params), params: baseParams })
  const checkData = useAsyncLoading({ fetchData: (_params) => fetchCheckData(_params), params: baseParams })
  const newCollectRef = useRef(null)
  const memberContributeRef = useRef(null)

  const depsUpdate = (oldDeps, newDeps) => {
    for (const key in newDeps) {
      if (oldDeps[key] !== newDeps[key]) {
        oldDeps[key] = newDeps[key]
      }
      if (typeof newDeps[key] === 'object') {
        depsUpdate(oldDeps[key], cloneDeep(newDeps[key]))
      }
    }
    return oldDeps
  }

  const fetchCollectData = async (_baseParams) => {
    const _params = cloneDeep(_baseParams)
    delete _params.startTime
    delete _params.endTime
    const result = await request.sget('zhikuan/mn/collect-statistic/v2/collect-summary', _params, 'collect_statistic_collect_summary')
    const _result = [{
      name: '今日采集',
      number: result.todayCollect,
      trigger: 'text',
      params: {
        ..._baseParams,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      }
    }, {
      name: '昨日采集',
      number: result.yesterdayCollect,
      trigger: 'text',
      params: {
        ..._baseParams,
        startTime: moment().subtract(1, 'd').format('YYYY-MM-DD'),
        endTime: moment().subtract(1, 'd').format('YYYY-MM-DD')
      }
    }, {
      name: '款式总计',
      number: result.allCollect,
      trigger: 'text',
      params: _baseParams
    }]
    depsUpdate(collectOption, _result)
    setCollectOption(_result)
  }

  const fetchCheckData = async (_baseParams) => {
    const result = await request.sget('zhikuan/mn/collect-statistic/v2/review-summary', _baseParams, 'collect_statistic_review_summary')
    setCheckOption([{
      name: '未提交',
      number: result.uncommitted,
      trigger: false
    }, {
      name: '待审核',
      number: result.pending,
      trigger: false
    }, {
      name: '已通过',
      number: result.pass,
      trigger: false
    }, {
      name: '已拒回',
      number: result.fail,
      trigger: false
    }])
  }

  const _onChange = (valueObj) => {
    setBaseParams(pre => ({ ...pre, ...valueObj, }))
  }
  const fetchData = (val, type) => {
    if (!type) {
      collectData?.onUpdate({ ...baseParams, ...val })
      checkData?.onUpdate({ ...baseParams, ...val })
    }
    memberContributeRef.current?.onUpdate({ ...baseParams, ...params, ...val })
    newCollectRef.current?.onUpdate({ ...baseParams, ...params, ...val })
  }

  const fetchCollectDetail = async (_baseParams) => {
    const result = await request.get('zhikuan/mn/collect-statistic/v2/collect-detail', { params: _baseParams })
    return result
  }

  const onParentClick = (_data, type) => {
    const { data } = _data
    if (type === 'pass') {
      window.open(`/meinian/home/coll/detail/${baseParams.inspirationId}?inspirationId=${baseParams.inspirationId}&userIdList=${data.itemKey}&markStatus=${1}&tab=`)
    } else {
      window.open(`/meinian/home/coll/detail/${baseParams.inspirationId}?inspirationId=${baseParams.inspirationId}&userIdList=${data.itemKey}&markStatus=${null}&tab=`)
    }
  }

  return (<div className={styles['meinian-inspiration-dynamic']}>
    <div className="header-sort">
      <UserSelect
        value={baseParams.userId}
        inspirationId={qsParams.inspirationId}
        onChange={value => {
          fetchData({ userId: value })
          _onChange({ userId: value })
        }}
      />
    </div>
    <section className="meinian-inspiration-dynamic-overview">
      <AnalysisOverview
        title="采集概览"
        fetchData={fetchCollectDetail}
        loading={collectData.loading}
        option={collectOption}
        style={{ marginRight: '24px', background: 'var(--m-fill-1)' }}
      />
      <AnalysisOverview
        title="审核概览"
        loading={checkData.loading}
        option={checkOption}
        style={{ background: 'var(--m-fill-1)' }}
      />
    </section>

    <div style={{ textAlign: 'right', padding: '8px 0' }}>
      <DatePicker
        startTime={params.startTime}
        endTime={params.endTime}
        noneText="统计时间"
        onChange={([startTime, endTime]) => {
          fetchData({ startTime, endTime }, '统计时间')
          setParams({ startTime, endTime })
        }}
      />
    </div>
    <LineChart
      style={{ background: 'var(--m-fill-1)' }}
      baseParams={{ ...baseParams, ...paramsRef.current }}
      ref={newCollectRef}
    />
    {
        !baseParams.userId && <MemberContribute
          style={{ marginTop: '32px', background: 'var(--m-fill-1)' }}
          baseParams={{ ...baseParams, ...paramsRef.current }}
          isInspiration={false}
          isLink
          ref={memberContributeRef}
          onParentClick={onParentClick}
        />
    }
  </div>)
}
